<template>
  <v-container>
    <div class="breadcrumbs-wrap">
      <v-breadcrumbs :items="breadcrumbs"></v-breadcrumbs>
    </div>
    <h1 class="title-pg">
      {{ voucher.bsoStrictReportingFormTypeName }} № {{ voucher.bsoNumber }} {{ voucher.ooptName }}
    </h1>
    <div class="my-organization">
      <div class="create-quota-pg bso-reports hunters-pg create bgw-pdg-20">
        <p class="status text-center" v-if="voucher.statusName">
          {{ $t('Статус') }}: {{ voucher.statusName }}
        </p>
        <h4 class="text-center mt-1">
          {{ voucher.bsoStrictReportingFormTypeName }} № {{ voucher.bsoNumber }}<br>{{ voucher.ooptName }}
        </h4>
        <v-form
          ref="form"
          lazy-validation
          enctype="multipart/form-data"
          @submit.prevent="save"
        >
          <div class="main-info-item">
            <v-row>
              <template v-if="voucher.voucherType === VOUCHER_TYPE_ONE_TIME">
                <v-col cols="12" md="2" :class="{ invalid: $v.voucher.validDateFrom.$error }">
                  <label>{{ $t('Срок действия с') }}:</label>
                  <div class="datepicker-main">
                    <div class="form-date size-sm">
                      <v-icon class="date-icon">date_range</v-icon>
                      <VueCtkDateTimePicker
                        v-model="voucher.validDateFrom"
                        format="DD.MM.YYYY"
                        formatted="LL"
                        :onlyDate="true"
                        :label="''"
                        :autoClose="true"
                        :noButton="true"
                      />
                    </div>
                  </div>
                </v-col>
                <v-col cols="12" md="2" :class="{ invalid: $v.voucher.validDateTo.$error }">
                  <label>{{ $t('по') }}:</label>
                  <div class="datepicker-main">
                    <div class="form-date size-sm">
                      <v-icon class="date-icon">date_range</v-icon>
                      <VueCtkDateTimePicker
                        v-model="voucher.validDateTo"
                        format="DD.MM.YYYY"
                        formatted="LL"
                        :onlyDate="true"
                        :label="''"
                        :autoClose="true"
                        :noButton="true"
                      />
                    </div>
                  </div>
                </v-col>
              </template>
              <v-col cols="12" md="4" :class="{ invalid: $v.voucher.observePlot.$error }">
                <label>{{ $t('Место пользования') }}:</label>
                <div class="select-def">
                  <v-select
                    item-value="id"
                    item-text="transName"
                    :items="observePlots"
                    v-model="voucher.observePlot"
                    outlined
                    dense
                    required
                    clearable
                  />
                </div>
              </v-col>
              <v-col cols="12" md="4">
                <label>{{ $t('Уточнение по месту пользования') }}:</label>
                <v-text-field
                  v-model="voucher.observePlotNote"
                  outlined
                  dense
                  class="hide-arrows"
                />
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" md="4" :class="{ invalid: $v.voucher.ooptHunter.$error }">
                <label>{{ $t('Охотник') }}:</label>
                <span v-if="ooptHunterFio">
                  <router-link tag="a" target='_blank' :to="{ name: 'hunter-show', params: { id: ooptHunterId } }">
                    {{ ooptHunterFio }}
                  </router-link>
                </span>
                <HunterSearchModal
                  :type="amateurSport"
                  @hunter-data="hunterData($event)"
                />
              </v-col>
            </v-row>
            <!--Добавить животное start-->
            <v-row v-for="(item, index)  in voucherFaunaData" :key="index">
              <v-col cols="12" md="4" :class="{ invalid: $v.voucherFaunaData.$each[index].fauna.$error }">
                <label>{{ $t('Вид') }}:</label>
                <div class="select-def">
                  <v-select
                    item-value="id"
                    item-text="transName"
                    :items="faunas"
                    v-model="item.fauna"
                    outlined
                    dense
                    required
                    clearable
                    return-object
                  />
                </div>
              </v-col>
              <v-col cols="12" md="8">
                <div class="quota-fields align-center">
                  <div class="quota-field field-block"
                       :class="{ invalid: $v.voucherFaunaData.$each[index].issuedHeadCount.$error }">
                    <label>{{ $t('Количество') }}:</label>
                    <v-text-field
                      v-model="item.issuedHeadCount"
                      type="number"
                      outlined
                      dense
                      class="size-small hide-arrows"
                    />
                  </div>
                  <template v-if="voucher.voucherType === VOUCHER_TYPE_SEASON">
                    <div class="quota-field field-block">
                      <label>{{ $t('Срок действия с') }}:</label>
                      <div class="datepicker-main">
                        <div class="form-date size-sm">
                          <v-icon class="date-icon">date_range</v-icon>
                          <VueCtkDateTimePicker
                            v-model="item.validDateFrom"
                            format="DD.MM.YYYY"
                            formatted="LL"
                            :onlyDate="true"
                            :label="''"
                            :autoClose="true"
                            :noButton="true"
                          />
                        </div>
                      </div>
                    </div>
                    <div class="quota-field field-block">
                      <label>{{ $t('по') }}:</label>
                      <div class="datepicker-main">
                        <div class="form-date size-sm">
                          <v-icon class="date-icon">date_range</v-icon>
                          <VueCtkDateTimePicker
                            v-model="item.validDateTo"
                            format="DD.MM.YYYY"
                            formatted="LL"
                            :onlyDate="true"
                            :label="''"
                            :autoClose="true"
                            :noButton="true"
                          />
                        </div>
                      </div>
                    </div>
                  </template>
                  <div class="quota-field pt-3">
                    <v-btn class="btn-delete" @click.native.stop="deleteFaunaItem(index)">
                      <v-icon>delete_forever</v-icon>
                    </v-btn>
                  </div>
                </div>
              </v-col>
            </v-row>
            <div class="form-group">
              <v-btn class="btn-add btn-add-small" @click.native.stop="addFaunaItem">
                <img src="@/assets/img/plus-icon.png" alt="icon">
                {{ $t('Добавить животное') }}
              </v-btn>
            </div>
            <!--Добавить животное end-->
            <v-row>
              <v-col cols="12" md="4" :class="{ invalid: $v.voucher.paymentSum.$error }">
                <div class="quota-fields align-center">
                  <div class="quota-field field-block mr-2">
                    <label>{{ $t('Сумма к оплате') }}:</label>
                    <v-text-field
                      v-model="voucher.paymentSum"
                      outlined
                      dense
                      clearable
                    />
                  </div>
                  <div class="quota-field pt-3">
                    <label>сом</label>
                  </div>
                </div>
              </v-col>
              <v-col cols="12" md="4" :class="{ invalid: $v.voucher.ooptObserver.$error }">
                <label>{{ $t('Ответственное лицо охотпользователя') }}:</label>
                <div class="select-def">
                  <v-select
                    item-value="id"
                    item-text="transFio"
                    :items="ooptObservers"
                    v-model="voucher.ooptObserver"
                    outlined
                    dense
                    required
                    clearable
                  />
                </div>
              </v-col>
              <v-col cols="12" md="4" :class="{ invalid: $v.voucher.issueDate.$error }">
                <label>{{ $t('Дата выдачи') }}:</label>
                <div class="datepicker-main">
                  <div class="form-date size-sm">
                    <v-icon class="date-icon">date_range</v-icon>
                    <VueCtkDateTimePicker
                      v-model="voucher.issueDate"
                      format="DD.MM.YYYY"
                      formatted="LL"
                      :onlyDate="true"
                      :label="''"
                      :autoClose="true"
                      :noButton="true"
                    />
                  </div>
                </div>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" md="4">
                <div class="form-group">
                <div class="quota-field" v-if="voucher.file">
                  <template
                    v-if="checkFileExist(voucher.fileExtension)"
                  >
                    <a
                      @click="previewDocumentDialog(voucher.id, true)"
                    >{{ $t('Скан путевки при выдаче') }}</a>
                    <v-dialog
                      v-model="previewDocsModal[voucher.id]"
                      max-width="1200"
                    >
                      <v-card class="modal">
                        <div class="modal-head">
                          {{ $t('Скан путевки при выдаче') }}
                          <v-btn
                            color="modal-close"
                            @click="previewDocumentDialog(voucher.id, false)"
                          >
                            <img src="@/assets/img/close-icon.png" alt="icon">
                          </v-btn>
                        </div>
                        <div class="modal-body">
                          <VueDocPreview
                            :value="backUrl + voucher.file"
                            type="office"
                          />
                        </div>
                      </v-card>
                    </v-dialog>
                  </template>
                  <template v-else>
                    <a
                      :href="backUrl + voucher.file"
                      target="_blank"
                    >{{ $t('Скан путевки при выдаче') }}</a>
                  </template>
                </div>
                <div class="file-input-link upload-file" :class="{ invalid: $v.voucherFile.$error }">
                  <v-file-input
                    accept=".pdf,.jpg,.png,.jpeg"
                    :label="$t('Загрузить скан путевки при выдаче')"
                    v-model="voucherFile"
                    clearable
                    ref="file"
                    @change="handleFileUpload()"
                  />
                </div>
              </div>
              </v-col>
            </v-row>
          </div>
          <div class="main-info-item">
            <!--Добавить Отметку-->
            <v-row v-for="(item, index)  in huntingDateMarks" :key="index">
              <v-col cols="12" md="4">
                <label>{{ $t('Отметка о выходе на охоту') }}:</label>
                <div class="datepicker-main">
                  <div class="form-date size-sm">
                    <v-icon class="date-icon">date_range</v-icon>
                    <VueCtkDateTimePicker
                      v-model="item.date"
                      format="DD.MM.YYYY"
                      formatted="LL"
                      :onlyDate="true"
                      :label="''"
                      :autoClose="true"
                      :noButton="true"
                    />
                  </div>
                </div>
              </v-col>
              <v-col cols="12" md="4">
                <div class="quota-fields align-center">
                  <div class="quota-field field-block"
                       :class="{ invalid: $v.huntingDateMarks.$each[index].huntsman.$error }">
                    <label>{{ $t('Егерь') }}:</label>
                    <div class="select-def size-md-2">
                      <v-select
                        item-value="id"
                        item-text="transFio"
                        :items="huntsmans"
                        v-model="item.huntsman"
                        outlined
                        dense
                        required
                        clearable
                      />
                    </div>
                  </div>
                  <div class="quota-field pt-3">
                    <v-btn class="btn-delete" @click.native.stop="deleteMarksItem(index)">
                      <v-icon>delete_forever</v-icon>
                    </v-btn>
                  </div>
                </div>
              </v-col>
            </v-row>
            <div class="form-group"
                 v-if="voucher.voucherType === VOUCHER_TYPE_SEASON || huntingDateMarks.length === 0">
              <v-btn class="btn-add btn-add-small" @click.native.stop="addMarksItem">
                <img src="@/assets/img/plus-icon.png" alt="icon">
                {{ $t('Добавить отметку') }}
              </v-btn>
            </div>
            <!--Добавить Отметку end-->
          </div>
          <div class="main-info-item">
            <v-row align="center" :class="{ invalid: $v.voucher.result.$error }">
              <v-col cols="12" md="4">
                <strong>{{ $t('Отчет о проведенной работе') }}:</strong>
              </v-col>
              <v-col cols="12" md="4">
                <div class="select-def">
                  <v-select
                    item-value="id"
                    item-text="transName"
                    :items="refVoucherResult"
                    v-model="voucher.result"
                    outlined
                    dense
                    required
                    clearable
                  />
                </div>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" md="12">
                <p>
                  <strong>{{ $t('На охоте добыто') }}:</strong>
                </p>
              </v-col>
            </v-row>
            <!--Добавить животное start-->
            <v-row v-for="(item, index)  in voucherFaunaData" :key="index">
              <v-col cols="12" md="4">
                <label>{{ $t('Вид') }}:</label>
                <p v-if="item.faunaName"><strong>{{ item.faunaName }}</strong></p>
                <p v-else-if="item.fauna"><strong>{{ item.fauna.transName }}</strong></p>
              </v-col>
              <v-col cols="12" md="4" :class="{ invalid: $v.voucherFaunaData.$each[index].catchHeadCount.$error }">
                <div class="quota-fields align-center">
                  <div class="quota-field field-block">
                    <label>{{ $t('Количество') }}:</label>
                    <v-text-field
                      v-model="item.catchHeadCount"
                      type="number"
                      outlined
                      dense
                      class="size-small hide-arrows"
                    />
                  </div>
                </div>
              </v-col>
            </v-row>
          </div>
          <div class="main-info-item">
            <div class="form-group">
              <div class="quota-field" v-if="voucher.finalFile">
                <template
                  v-if="checkFileExist(voucher.finalFileExtension)"
                >
                  <a
                    @click="previewDocumentDialog(voucher.id, true)"
                  >{{ $t('Финальный скан путевки') }}</a>
                  <v-dialog
                    v-model="previewDocsModal[voucher.id]"
                    max-width="1200"
                  >
                    <v-card class="modal">
                      <div class="modal-head">
                        {{ $t('Финальный скан путевки') }}
                        <v-btn
                          color="modal-close"
                          @click="previewDocumentDialog(voucher.id, false)"
                        >
                          <img src="@/assets/img/close-icon.png" alt="icon">
                        </v-btn>
                      </div>
                      <div class="modal-body">
                        <VueDocPreview
                          :value="backUrl + voucher.finalFile"
                          type="office"
                        />
                      </div>
                    </v-card>
                  </v-dialog>
                </template>
                <template v-else>
                  <a
                    :href="backUrl + voucher.finalFile"
                    target="_blank"
                  >{{ $t('Финальный скан путевки') }}</a>
                </template>
              </div>
              <div class="file-input-link upload-file" :class="{ invalid: $v.voucherFinalFile.$error }">
                <v-file-input
                  accept=".pdf,.jpg,.png,.jpeg"
                  :label="$t('Загрузить финальный скан путевки')"
                  v-model="voucherFinalFile"
                  clearable
                  ref="file"
                  @change="handleFinalFileUpload()"
                />
              </div>
            </div>
            <!--Кнопки действии-->
            <div class="form-action text-center">
              <button
                class="btn btn-default blue"
                type="submit"
                @click="statusId = filledStatus"
              >
                {{ $t('Сохранить') }}
              </button>
              <button
                class="btn btn-default blue"
                type="submit"
                @click="statusId = sentStatus"
              >
                {{ $t('Сохранить и отправить') }}
              </button>
              <button
                class="btn btn-default gray"
                type="button"
                @click="onCancel"
              >
                {{ $t('Отмена') }}
              </button>
            </div>
          </div>
        </v-form>
      </div>
    </div>
  </v-container>
</template>

<script>
import { mapMutations } from 'vuex'
import Voucher from '@/model/voucher'
import VueDocPreview from 'vue-doc-preview'
import HunterSearchModal from '@/components/bso/HunterSearchModal'
import { required, requiredIf } from 'vuelidate/lib/validators'

export default {
  components: {
    VueDocPreview,
    HunterSearchModal
  },
  data: () => ({
    breadcrumbs: [],
    voucher: {},
    voucherFaunaData: [],
    huntingDateMarks: [],
    refVoucherResult: [],
    ooptObservers: [],
    faunas: [],
    huntsmans: [],
    observePlots: [],
    hunters: [],
    VOUCHER_TYPE_ONE_TIME: null,
    VOUCHER_TYPE_SEASON: null,
    voucherFile: null,
    previewDocsModal: [],
    backUrl: process.env.VUE_APP_BACK_URL,
    filledStatus: null,
    sentStatus: null,
    statusId: null,
    ooptHunterFio: null,
    ooptHunterId: null,
    amateurSport: null,
    voucherFinalFile: null
  }),
  validations: {
    voucher: {
      observePlot: { required },
      ooptHunter: { required },
      paymentSum: { required },
      ooptObserver: { required },
      issueDate: { required },
      validDateFrom: {
        required: requiredIf(function () {
          return this.voucher.voucherType === this.VOUCHER_TYPE_ONE_TIME
        })
      },
      validDateTo: {
        required: requiredIf(function () {
          return this.voucher.voucherType === this.VOUCHER_TYPE_ONE_TIME
        })
      },
      result: {
        required: requiredIf(function () {
          return this.statusId === this.sentStatus
        })
      }
    },
    voucherFile: {
      required: requiredIf(function () {
        return this.voucher.file === null
      })
    },
    voucherFinalFile: {
      required: requiredIf(function () {
        return this.voucher.finalFile === null && this.statusId === this.sentStatus
      })
    },
    voucherFaunaData: {
      $each: {
        fauna: { required },
        issuedHeadCount: { required },
        catchHeadCount: { required }
      }
    },
    huntingDateMarks: {
      $each: {
        huntsman: { required }
      }
    }
  },
  mounted () {
    this.fetchData()
    this.scrollToTop()
  },
  methods: {
    ...mapMutations(['setLoading']),
    fetchData () {
      this.setLoading(true)
      Voucher.getVoucherInfo(this.$route.params.id).then((response) => {
        this.voucher = response.data.voucher
        this.voucherFaunaData = response.data.voucherFaunaData
        this.huntingDateMarks = response.data.huntingDateMarks
        this.VOUCHER_TYPE_ONE_TIME = response.data.VOUCHER_TYPE_ONE_TIME
        this.VOUCHER_TYPE_SEASON = response.data.VOUCHER_TYPE_SEASON
        this.amateurSport = response.data.amateurSport
        if (this.voucher.ooptHunter) {
          this.ooptHunterId = this.voucher.ooptHunter
        }
        if (this.voucher.ooptHunterFio) {
          this.ooptHunterFio = this.voucher.ooptHunterFio
        }
        Voucher.getVoucherFormData(this.$route.params.id).then((response) => {
          this.refVoucherResult = response.data.refVoucherResult
          this.ooptObservers = response.data.ooptObservers
          this.faunas = response.data.faunas
          this.huntsmans = response.data.huntsmans
          this.observePlots = response.data.observePlots
          this.hunters = response.data.hunters
          this.filledStatus = response.data.filledStatus
          this.sentStatus = response.data.sentStatus
          this.generateBreadcrumbs()
          this.setLoading(false)
        }).catch((error) => {
          console.log(error)
          this.setLoading(false)
        })
      }).catch((error) => {
        console.log(error)
        this.$router.push({
          name: 'error',
          params: {
            status: error.response.status
          }
        })
        this.setLoading(false)
      })
    },
    save () {
      if (!this.validateForm()) {
        return
      }
      if (this.huntingDateMarks.length === 0 && this.statusId === this.sentStatus) {
        this.$noty.error(this.$i18n.t('Внимание! Добавьте хотя бы одну отметку.'), {
          killer: true,
          timeout: 1000,
          layout: 'topRight'
        })
        return
      }
      if (this.voucherFaunaData.length === 0) {
        this.$noty.error(this.$i18n.t('Внимание! Добавьте хотя бы одну информацию о животных.'), {
          killer: true,
          timeout: 1000,
          layout: 'topRight'
        })
        return
      }
      this.setLoading(true)

      const formEl = this.$refs.form.$el
      const formData = new FormData(formEl)

      formData.append('voucher[validDateFrom]', this.voucher.validDateFrom ? this.voucher.validDateFrom : '')
      formData.append('voucher[validDateTo]', this.voucher.validDateTo ? this.voucher.validDateTo : '')
      formData.append('voucher[issueDate]', this.voucher.issueDate)
      formData.append('voucher[paymentSum]', this.voucher.paymentSum)
      formData.append('voucher[observePlotNote]', (this.voucher.observePlotNote && this.voucher.observePlotNote !== null) ? this.voucher.observePlotNote : '')
      formData.append('voucher[observePlot]', this.voucher.observePlot)
      formData.append('voucher[ooptObserver]', this.voucher.ooptObserver)
      formData.append('voucher[ooptHunter]', this.voucher.ooptHunter)
      formData.append('voucher[uploadedFile]', this.voucherFile)
      if (this.voucherFinalFile) {
        formData.append('voucher[uploadedFinalFile]', this.voucherFinalFile)
      }
      if (this.voucher.result) {
        formData.append('voucher[result]', this.voucher.result)
      }

      // Добавление отметок
      this.huntingDateMarks.forEach(function (element, index) {
        formData.append(`voucher[huntingDateMarks][${index}][date]`, element.date ? element.date : '')
        formData.append(`voucher[huntingDateMarks][${index}][huntsman]`, element.huntsman)
      })

      // Добавление видов животных и проверка на дублирование
      const faunaIds = []
      this.voucherFaunaData.forEach(function (element, index) {
        faunaIds.push(element.fauna.id !== undefined ? element.fauna.id : element.fauna)
        formData.append('voucher[voucherFaunaData][' + index + '][fauna]', element.fauna.id !== undefined ? element.fauna.id : element.fauna)
        formData.append('voucher[voucherFaunaData][' + index + '][validDateFrom]', element.validDateFrom ? element.validDateFrom : '')
        formData.append('voucher[voucherFaunaData][' + index + '][validDateTo]', element.validDateTo ? element.validDateTo : '')
        formData.append('voucher[voucherFaunaData][' + index + '][issuedHeadCount]', element.issuedHeadCount)
        formData.append('voucher[voucherFaunaData][' + index + '][catchHeadCount]', element.catchHeadCount)
      })
      const filterFaunaIds = faunaIds.filter((v, i, a) => a.indexOf(v) === i)
      if (filterFaunaIds.length !== faunaIds.length) {
        this.setLoading(false)
        this.$noty.error(this.$i18n.t('Внимание! В форме выбраны повторяющиеся виды животных.'), {
          killer: true,
          timeout: 1000,
          layout: 'topRight'
        })
        return
      }

      Voucher.editVoucher(this.$route.params.id, this.statusId, formData).then((response) => {
        this.$router.push({
          name: 'voucher-view',
          params: {
            id: this.$route.params.id
          }
        })
      }).catch((error) => {
        console.log(error)
        let msg = error.message
        if (error.response) {
          if (error.response.data.form) {
            msg = this.$i18n.t(error.response.data.form.message)
          } else if (error.response.data.message) {
            msg = this.$i18n.t(error.response.data.message)
          }
        }
        this.$noty.error(msg, {
          killer: true,
          timeout: 2000,
          layout: 'topRight'
        })
      })
      this.setLoading(false)
    },
    // Валидация формы
    validateForm () {
      this.$v.$touch()

      if (this.$v.$invalid) {
        this.$nextTick(() => {
          this.scrollToFirstError()
        })

        return false
      }

      return true
    },
    // Прокручивание до поля с ошибкой
    scrollToFirstError () {
      const domRect = document.querySelector('.invalid').getBoundingClientRect()
      window.scrollTo(
        domRect.left +
        (document.body.scrollLeft || document.documentElement.scrollLeft),
        domRect.top +
        (document.body.scrollTop || document.documentElement.scrollTop) -
        90
      )
    },
    // установка данных выбранного охотника
    hunterData (result) {
      this.voucher.ooptHunter = result.id
      this.voucher.ooptHunterFio = result.fio
      this.ooptHunterId = result.id
      this.ooptHunterFio = result.fio
    },
    // добавляем доп поле для животных
    addFaunaItem () {
      this.voucherFaunaData.push({
        fauna: null,
        validDateFrom: null,
        validDateTo: null,
        issuedHeadCount: null,
        catchHeadCount: null
      })
    },
    // удаляем доп поле из списка животных
    deleteFaunaItem (index) {
      this.voucherFaunaData.splice(index, 1)
    },
    // Добавляем поля отметки
    addMarksItem () {
      this.huntingDateMarks.push({
        date: null,
        huntsman: null
      })
    },
    // удаляем доп поле из списка отметки
    deleteMarksItem (index) {
      this.huntingDateMarks.splice(index, 1)
    },
    // генерация хлебных крошек
    generateBreadcrumbs () {
      this.breadcrumbs = [
        {
          text: this.$i18n.t('Главная'),
          disabled: false,
          href: '/'
        },
        {
          text: this.$i18n.t('Рабочий кабинет'),
          disabled: false,
          href: '/my-organization'
        },
        {
          text: this.$i18n.t('Путевки'),
          disabled: false,
          href: '/voucher-list'
        },
        {
          text: this.$i18n.t('Редактирование'),
          disabled: true
        }
      ]
    },
    handleFileUpload () {
      if (this.voucherFile) {
        this.createFile(this.voucherFile)
      }
    },
    handleFinalFileUpload () {
      if (this.voucherFinalFile) {
        this.createFile(this.voucherFinalFile)
      }
    },
    createFile (file) {
      const reader = new FileReader()
      const vm = this

      reader.onload = (e) => {
        vm.image = e.target.result
      }
      reader.readAsDataURL(file)
    },
    // предпросмотр файлов
    previewDocumentDialog (id, flag) {
      this.$set(this.previewDocsModal, id, flag)
    },
    checkFileExist (ext) {
      const fileExtensions = ['doc', 'docx', 'xls', 'xlsx']
      const exist = fileExtensions.some(function (field) {
        return field === ext
      })
      return exist
    },
    // отмена
    onCancel () {
      this.voucher.statusId
        ? this.$router.push({
          name: 'voucher-view',
          params: {
            id: this.$route.params.id
          }
        }) : this.$router.push({
          name: 'voucher-list'
        })
    },
    // Прокручивание к началу страницы
    scrollToTop () {
      window.scrollTo(0, 0)
    }
  }
}
</script>
<style>
  .v-text-field__slot .v-label {
    max-width: 100% !important;
  }
  .file-input-link .v-input {
    max-width: 310px;
  }
</style>
